import { render, staticRenderFns } from "./EditorFooter.vue?vue&type=template&id=63455bd4&scoped=true"
import script from "./EditorFooter.vue?vue&type=script&lang=js"
export * from "./EditorFooter.vue?vue&type=script&lang=js"
import style0 from "./EditorFooter.vue?vue&type=style&index=0&id=63455bd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63455bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63455bd4')) {
      api.createRecord('63455bd4', component.options)
    } else {
      api.reload('63455bd4', component.options)
    }
    module.hot.accept("./EditorFooter.vue?vue&type=template&id=63455bd4&scoped=true", function () {
      api.rerender('63455bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalculateEditor/EditorFooter.vue"
export default component.exports